import { createAsyncThunk } from '@reduxjs/toolkit';
import { BorrowerInputVariables } from '@sparrow-card/sparrow-card-constants';
import type ApplicationApi from 'api/digifi/application/ApplicationApi';
import type { SubmitApplicationRequestBody } from 'api/digifi/application/ApplicationApi';
import { DEBOUNCE_TIMEOUT } from 'thunks/thunks.config';
import debounce from 'utils/debounce';
import { logger } from 'utils/logger';

export const submitApplication = (api: ApplicationApi) => {
  const debouncedApiCall = debounce(
    (data: SubmitApplicationRequestBody) => api.submitApplication(data),
    DEBOUNCE_TIMEOUT,
  );

  return createAsyncThunk('pages/submitApplication', async (data: SubmitApplicationRequestBody) => {
    const email = data.applicationData[BorrowerInputVariables.Email];

    try {
      logger.info(`Submit application started for: ${email}`);

      const result = await debouncedApiCall(data);
      const applicationId = 'application' in result ? result.application?.id : undefined;

      logger.info(`Submit application finished for: ${email}. ApplicationId: ${applicationId}`);

      return result;
    } catch (error) {
      logger.error(`Submit application request failed for: ${email}`, error);
      throw error;
    }
  });
};
